import React from 'react'
import Navbar from '../Navbar/Navbar'
import HeroSection from '../HeroSection/HeroSection'
import CollectionSection from '../CollectionSection/CollectionSection'
import AuctionLegacySection from '../AuctionLegacySection/AuctionLegacySection'
import NewArrivals from '../NewArrivals/NewArrivals'
import TrustSection from '../TrustSection/TrustSection'
import Footer from '../Footer/Footer'

function HomePage() {
  return (
    <div>
        <Navbar/>
        <HeroSection/>
        <CollectionSection/>
        <AuctionLegacySection/>
        <NewArrivals/>
        <TrustSection/>
        <Footer/>
    </div>
  )
}

export default HomePage